module.exports = __webpack_public_path__ + "static/img/our-customers-industry-img-full.614e214.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/our-customers/our-customers-industry-img-full.jpg
// module id = OI2S
// module chunks = 0